import { Box, Grid, FormGroup, Checkbox } from "@mui/material"

const AdvanceArrearsDetails = ({ advanceData, onFieldChange, modeType, error, onFocusChange }) => {
  return (
    <Grid container spacing={1}>
      <Grid size={{ md: 12, xs: 12 }}>
        <Box sx={{ backgroundColor: "#f2f2f2", paddingBottom: error.is_advanced ? "6px" : null }} >
          <Box sx={{ display: "flex", padding: "0px 0px 0px 12px", }}>
            <FormGroup className='disabled-checkbox-wrapper'>
              <Box className="check-item-div" sx={{ cursor: modeType === "view" ? "not-allowed" : "pointer" }}>
                <Checkbox
                  size="small"
                  disableRipple
                  checked={advanceData?.is_advanced}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    onFieldChange("is_advanced", checked);
                    onFocusChange("is_advanced");
                  }}
                  disabled={modeType === "view"}
                />
                <span className="check-item-span file-name">Advanced</span>
              </Box>
            </FormGroup>
            <FormGroup className='disabled-checkbox-wrapper'>
              <Box className="check-item-div" sx={{ cursor: modeType === "view" ? "not-allowed" : "pointer" }}>
                <Checkbox
                  size="small"
                  disableRipple
                  checked={advanceData?.is_arrears}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    onFieldChange("is_arrears", checked);
                    onFocusChange("is_advanced");
                  }}
                  disabled={modeType === "view"}
                />
                <span className="check-item-span file-name">Arrears</span>
              </Box>
            </FormGroup>
          </Box>
          <Box className="mui-error-text">{error.is_advanced}</Box>
        </Box>
      </Grid>
    </Grid>
  )
}

export default AdvanceArrearsDetails


